import axios from "axios";
import * as AppSettingsService from "./AppSettingsService";
import {
  AddTempGroceryCartPayload,
  BatchFetchImagePayload,
  CachedGrocery,
  CartCostDetails,
  CartCostDetailsPayload,
  GroceryCategory,
  GroceryDeliveryAvailability,
  GroceryItem,
  GroceryItemsRequestBody,
  ImageContentResponse,
} from "../types/GroceryTypes";

const appSettings = AppSettingsService;

export async function getGroceryDeliveryAvailability(
  organizationId: number
): Promise<GroceryDeliveryAvailability> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Grocery/v1/GetGroceryDeliveryWindow?organizationId=${organizationId}`;
    const response = await axios.get(baseUrl);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getGroceryCategoryByOrganizationId(
  organizationId: number,
  isActive: boolean
): Promise<GroceryCategory[]> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/common/Grocery/v1/GetGroceryCategoryByOrganizationId?organizationId=${organizationId}&isActive=${isActive}`;
    const response = await axios.get(baseUrl);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getGroceryDashboard(
  requestBody: GroceryItemsRequestBody
): Promise<GroceryItem[]> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Grocery/v1/GetGroceryDashboard`;
    const response = await axios.post(baseUrl, requestBody);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function batchDownloadImageContent(
  data: BatchFetchImagePayload
): Promise<ImageContentResponse[]> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Grocery/v1/GetDownloadFileDetails?folderName=${
      data.folderName
    }`;
    const response = await axios.post(baseUrl, data.imageKeys);

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getTemporaryGroceryCart(
  serviceUserPersonId: number
): Promise<CachedGrocery> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Grocery/v1/GetTempGroceryCart?serviceUserPersonId=${serviceUserPersonId}`;
    const response = await axios.get(baseUrl);

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function addTempGroceryCart(
  requestBody: AddTempGroceryCartPayload
): Promise<void> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Grocery/v1/AddTempGroceryCart`;
    const response = await axios.post(baseUrl, requestBody);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function deleteTempGroceryCart(
  personId: number,
  deleteAction: number
): Promise<void> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Grocery/v1/DeleteTempGroceryCart?serviceUserPersonId=${personId}&deleteAction=${deleteAction}`;
    const response = await axios.delete(baseUrl);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function updateGroceryCartDetails(
  requestBody: CartCostDetailsPayload
): Promise<CartCostDetails> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Grocery/v1/UpdateGroceryCart`;
    const response = await axios.post(baseUrl, requestBody);
    return response.data;
  } catch (error) {
    throw error;
  }
}
